import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCollapseAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14.024 16.277a.75.75 0 0 1-1.06 0L10 13.314l-2.964 2.963a.75.75 0 1 1-1.06-1.06l3.494-3.494a.75.75 0 0 1 1.06 0l3.494 3.493a.75.75 0 0 1 0 1.061m0-12.554a.75.75 0 0 1 0 1.06L10.53 8.277a.75.75 0 0 1-1.06 0L5.975 4.783a.75.75 0 0 1 1.06-1.06L10 6.686l2.963-2.963a.75.75 0 0 1 1.061 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCollapseAll;
